import React from "react";

const DataUPAP = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Penumpang UPAP"
        src="https://paques.jaktraffic.my.id/#/pdsshare/dashboard/view/shared?sid=140&standalone=true&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJFeHBpcmVkIjoyMDkxMTUwMzM5LCJJZGVudGl0eSI6MTQwLCJUb2tlblR5cGUiOjB9.ML9zigHiz5na_i5dcm5bq5jnPddEwDePdGvq5_oIUps&theme=dark"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default DataUPAP;
